import { baseUrl } from "../../../boot/index";
import axios from "axios";


export const addTask = async (formData) => {
    // console.log('fffffff')
    const token = localStorage.getItem("authToken")
    // console.log('<<<<<<token',token)
    try {
      const response = await axios.post(`${baseUrl}cleaningappfunctions/operations/app/v1/create-Task`, formData, {
        headers: {
          "auth-token": token,
        }
      },)
      // console.log({'<<<<<<<<taskdata':response})
      return response; 
    } catch (error) {
      console.log({ error })
      throw error
    }
  }
  

  export const updateTask = async (data) => {
    // console.log( "????????????????????????dataaaaaaaaaaaaaaa",data )
    const ROWID = data?.tab[0]?.rows[0]?.ROWID; 
    // console.log('updateeeeeeeeee',ROWID)
    const token = localStorage.getItem("authToken")
    try {
      const response = await axios.put(`${baseUrl}cleaningappfunctions/operations/app/v1/update-task/${ROWID}`, data, {
        headers: {
          "auth-token": token,
        }
      },)
      return response;
    } catch (error) {
      throw error
    }
  }
  // delete Sites 
  export const deleteTask = async (ROWID) => {
    // console.log({'<<<<<<<<<<<<<<<<<<<<<<<<<ROWID>>>>>>>>>>>>>>':ROWID })
    const token = localStorage.getItem("authToken")
    try {
      const response = await axios.delete(`${baseUrl}cleaningappfunctions/operations/app/v1/delete-Task/${ROWID}`, {
        headers: {
          "auth-token": token,
        }
      },)
      return response;
    } catch (error) {
      console.log("Error is - ", error)
      throw error
    }
  }







  export const createTask = async (formData) => {
    const token = localStorage.getItem("authToken")
    try {
      const response = await axios.post(`${baseUrl}cleaningappfunctions/operations/app/v1/create-new-task`, formData, {
        headers: {
          "auth-token": token,
        }
      },)
      return response; 
    } catch (error) {
      console.log({ error })
      throw error
    }
  }

  // Update API
export const updateTasks = async (formData) => {
 
  const token = localStorage.getItem("authToken")
  try {
    const response = await axios.put(`${baseUrl}cleaningappfunctions/operations/app/v1/update-new-task`, formData, {
      headers: {
        "auth-token": token,
      }
    },)
    return response;
  } catch (error) {
    throw error
  }
}